export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-2 cursor-pointer">
              <i className="ri-windy-line text-2xl text-cyan-600"></i>
              <span className="text-xl font-bold text-slate-800">合同会社ｌｕｃｅ</span>
            </a>
            <a 
              href="/"
              className="text-slate-700 hover:text-cyan-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              ホームに戻る
            </a>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-8">
            プライバシーポリシー
          </h1>

          <div className="prose prose-slate max-w-none">
            <p className="text-slate-600 mb-8">
              合同会社ｌｕｃｅ（以下「当社」といいます）は、お客様の個人情報の保護に最大限の注意を払い、以下のプライバシーポリシーに従って適切に取り扱います。
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">1. 個人情報の定義</h2>
              <p className="text-slate-600 leading-relaxed">
                個人情報とは、お客様個人に関する情報であって、当該情報に含まれる氏名、会社名、電話番号、メールアドレスその他の記述等により特定の個人を識別できるものをいいます。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">2. 個人情報の収集</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                当社は、以下の目的のために必要な範囲で個人情報を収集することがあります。
              </p>
              <ul className="list-disc list-inside space-y-2 text-slate-600">
                <li>お問い合わせへの対応</li>
                <li>サービスの提供</li>
                <li>見積もりの作成</li>
                <li>契約の履行</li>
                <li>アフターサービスの提供</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">3. 個人情報の利用目的</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                当社は、収集した個人情報を以下の目的で利用いたします。
              </p>
              <ul className="list-disc list-inside space-y-2 text-slate-600">
                <li>お客様へのサービス提供</li>
                <li>お問い合わせへの回答</li>
                <li>見積もり・契約書類の作成</li>
                <li>作業日程の調整・連絡</li>
                <li>請求書の発行・代金の請求</li>
                <li>サービス向上のための分析</li>
                <li>新サービスのご案内（お客様の同意がある場合のみ）</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">4. 個人情報の第三者提供</h2>
              <p className="text-slate-600 leading-relaxed">
                当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません。
              </p>
              <ul className="list-disc list-inside space-y-2 text-slate-600 mt-4">
                <li>お客様の同意がある場合</li>
                <li>法令に基づく場合</li>
                <li>人の生命、身体または財産の保護のために必要がある場合</li>
                <li>業務委託先に必要な範囲で提供する場合（適切な管理を行います）</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">5. 個人情報の管理</h2>
              <p className="text-slate-600 leading-relaxed">
                当社は、個人情報の漏洩、滅失、毀損等を防止するため、適切な安全管理措置を講じます。また、個人情報を取り扱う従業員に対して、適切な監督を行います。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">6. 個人情報の開示・訂正・削除</h2>
              <p className="text-slate-600 leading-relaxed">
                お客様は、当社が保有する自己の個人情報について、開示、訂正、削除を請求することができます。請求があった場合、当社は速やかに対応いたします。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">7. Cookie等の使用</h2>
              <p className="text-slate-600 leading-relaxed">
                当社のウェブサイトでは、サービスの利便性向上のためCookie等の技術を使用することがあります。Cookieの使用を希望されない場合は、ブラウザの設定で無効にすることができます。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">8. プライバシーポリシーの変更</h2>
              <p className="text-slate-600 leading-relaxed">
                当社は、法令の変更等に伴い、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、当社ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">9. お問い合わせ窓口</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください。
              </p>
              <div className="bg-cyan-50 p-6 rounded-lg">
                <p className="text-slate-800 font-bold mb-2">合同会社ｌｕｃｅ</p>
                <p className="text-slate-600">東京都世田谷区松原２丁目２１番１０号ＢＥＳ明大前コート１０２</p>
                <p className="text-slate-600">個人情報保護管理者：代表</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              &copy; 2026 合同会社ｌｕｃｅ. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
